module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-contact",
    attrs: {
      "id": "section-contact"
    }
  }, [_c('div-columns', {
    attrs: {
      "column-num": "is-8"
    }
  }, [_c('form-dynamix', {
    attrs: {
      "type": "team",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "no-print": _vm.noPrint,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf,
      "is-rerender": _vm.isRerender
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20eca1ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactSection.vue
// module id = 806
// module chunks = 1